import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PartnerCTA() {
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 300 });
  const { ref: btnRef, revealed: btnRevealed } = useScrollReveal({ delay: 450 });
  const { ref: footRef, revealed: footRevealed } = useScrollReveal({ delay: 550 });

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="rounded-2xl bg-background-50 border border-background-200/70 p-8 md:p-12 lg:p-16 text-center relative overflow-hidden max-w-[720px] mx-auto">
          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full blur-3xl pointer-events-none" style={{ background: 'oklch(var(--primary-500) / 0.08)' }} />
          <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full blur-3xl pointer-events-none" style={{ background: 'oklch(var(--accent-500) / 0.06)' }} />

          <div className="relative z-10 max-w-[600px] mx-auto">
            <span className="text-[12px] font-semibold uppercase tracking-[0.18em] text-accent-600">
              Начните зарабатывать
            </span>

            <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
              Готовы стать партнёром и получать до 30% с каждого клиента?
            </h2>

            <p ref={descRef} className={`mt-4 text-[15px] md:text-[16px] text-foreground-500 leading-relaxed reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
              Напишите нам в Telegram. Обсудим детали, ответим на вопросы, подготовим партнёрскую ссылку и материалы — и вы сможете начать зарабатывать уже сегодня.
            </p>

            <div ref={btnRef} className={`mt-7 reveal-fade-up ${btnRevealed ? 'revealed' : ''}`}>
              <a
                href="https://t.me/anna_aigam"
                target="_blank"
                rel="noopener noreferrer"
                className="h-12 px-7 inline-flex items-center gap-2 justify-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-telegram-line text-lg"></i>
                Написать в Telegram
              </a>
            </div>

            <p ref={footRef} className={`mt-5 text-[13px] text-foreground-400 reveal-fade-up ${footRevealed ? 'revealed' : ''}`}>
              Отвечаем в течение часа в рабочее время. Пн–Пт, 10:00–19:00 МСК.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}